import React from "react";
import { Row, Col } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { HookFormRadioButton } from "components";
import { PaymentTypes } from "types";

type PaymentTypeProps = {
	isLoading?: boolean;
	sectionName: string;
	paymentTypeName: string;
	sectionTitle?: string;
	index: number;
};

const PaymentType = ({
	isLoading = false,
	sectionName,
	index,
	sectionTitle = "Payment Types",
	paymentTypeName,
}: PaymentTypeProps) => {
	const { register } = useFormContext();

	return (
		<>
			<p>{sectionTitle}</p>
			<Row className="form-group">
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.${index}.paymentTypeAch`}
						name={paymentTypeName}
						register={register}
						value={PaymentTypes.ach.name}
						label={PaymentTypes.ach.displayName}
						blurLoading={isLoading}
					/>
				</Col>
			</Row>
		</>
	);
};

export default PaymentType;
